import { Component, OnInit, Input } from '@angular/core';
import { access } from 'fs';

interface enlace {
  icono: string,
  name: string,
  access: Array<number>,
  sub: any,
  links: Array<any>
}

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styles: []
})
export class SidebarComponent implements OnInit {

  @Input() usuario: any;

  public enlaces: enlace[] = [
    {
      icono: 'icon-people',
      name: 'Clientes',
      access: [1, 2, 3],
      sub: false,
      links: [
        { link: ['/customers/index'], text: 'Ver clientes', access: [1, 2, 3] },
        { link: ['/customers/new'], text: 'Nuevo cliente', access: [1, 2] }
      ]
    },
    {
      icono: 'icon-clock',
      name: 'Casos',
      access: [1, 2, 3],
      sub: {
        icono: 'icon-tag',
        name: 'Etiquetas',
        access: [1, 2, 3],
        links: [
          { link: ['/events/status/index'], text: 'Ver etiquetas', access: [1, 2, 3] },
          { link: ['/events/status/add'], text: 'Crear etiqueta', access: [1, 2] }
        ]
      },
      links: [
        { link: ['/events/index'], text: 'Ver casos', access: [1, 2, 3] },
        { link: ['/events/new'], text: 'Crear caso', access: [1, 2] },
      ]
    },
    {
      icono: 'icon-doc',
      name: 'Reportes',
      access: [1, 2, 3],
      sub: false,
      links: [
        { link: ['/reports/index'], text: 'Reporte general', access: [1, 2] }
      ]
    },
    {
      icono: 'icon-user',
      name: 'Usuarios',
      access: [1, 2],
      sub: false,
      links: [
        { link: ['/users/index'], text: 'Ver usuarios', access: [1, 2] }
      ]
    }
  ];

  constructor() { }

  ngOnInit() {
    this.verificarPermisos();
  }

  private verificarPermisos() {
    for (var key in this.enlaces) {
      if (!(this.enlaces[key].access.indexOf(this.usuario.rol.nivel) > 0)) {
        for (let f = 0; f < this.enlaces[key].links.length; f++) {
          if (this.enlaces[key].links[f].access.indexOf(this.usuario.rol.nivel) < 0) {
            this.enlaces[key].links.splice(f, 1);
          }
          if (this.enlaces[key].sub) {
            for (let i = 0; i < this.enlaces[key].sub.links.length; i++) {
              if (this.enlaces[key].sub.links[i].access.indexOf(this.usuario.rol.nivel) < 0) {
                this.enlaces[key].sub.links.splice(i, 1);
              }
            }
          }
        }
      } else {
        this.enlaces.splice(parseInt(key), 1);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sidebar/sidebar.component.ts